// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.games-page {
  max-width: 900px;
  margin: 0 auto;
}

.games-page h1 {
  margin-bottom: 8px;
}

.subtitle {
  color: var(--text-light);
  margin-bottom: 24px;
}

/* Category Section Title */
.category-section-title {
  font-size: 16px;
  color: var(--text);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-section-title.new-section {
  margin-top: 28px;
}

/* Category Set Group */
.category-set-group {
  margin-bottom: 20px;
}

.category-set-heading {
  font-size: 14px;
  color: var(--text-light);
  margin: 16px 0 8px 0;
  padding-left: 4px;
  font-weight: 500;
}

.category-set-group:first-child .category-set-heading {
  margin-top: 0;
}

/* Category Grid */
.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}

.category-card {
  background: white;
  border: 3px solid var(--cat-color);
  border-radius: 16px;
  padding: 20px 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
}

.category-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  background: var(--cat-color);
}

.category-card:hover .category-name {
  color: white;
}

.category-icon {
  font-size: 40px;
  display: block;
}

.category-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
  line-height: 1.2;
}

/* Learned category badge */
.category-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: var(--success);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

/* Unlearned categories - grayed out */
.category-card.unlearned {
  border-color: #ddd;
  opacity: 0.6;
}

.category-card.unlearned .category-icon {
  filter: grayscale(70%);
}

.category-card.unlearned:hover {
  opacity: 1;
  border-color: var(--cat-color);
  background: var(--cat-color);
}

.category-card.unlearned:hover .category-icon {
  filter: none;
}

/* Selected Category Banner */
.selected-category {
  background: var(--cat-color);
  border-radius: 16px;
  padding: 16px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
  box-shadow: var(--shadow);
}

.selected-icon {
  font-size: 36px;
}

.selected-name {
  font-size: 20px;
  font-weight: 700;
  flex: 1 1;
}

.change-category-btn {
  background: rgba(255, 255, 255, 0.25);
  border: none;
  color: white;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.change-category-btn:hover {
  background: rgba(255, 255, 255, 0.4);
}

/* Games Grid */
.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.game-card {
  background: white;
  border-radius: 20px;
  padding: 28px 20px;
  text-align: center;
  text-decoration: none;
  color: var(--text);
  box-shadow: var(--shadow);
  transition: transform 0.2s, box-shadow 0.2s;
}

.game-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.game-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

.game-card h3 {
  font-size: 18px;
  margin-bottom: 6px;
}

.game-card p {
  font-size: 13px;
  color: var(--text-light);
}

`, "",{"version":3,"sources":["webpack://./src/pages/Games.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".games-page {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.games-page h1 {\n  margin-bottom: 8px;\n}\n\n.subtitle {\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n/* Category Section Title */\n.category-section-title {\n  font-size: 16px;\n  color: var(--text);\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.category-section-title.new-section {\n  margin-top: 28px;\n}\n\n/* Category Set Group */\n.category-set-group {\n  margin-bottom: 20px;\n}\n\n.category-set-heading {\n  font-size: 14px;\n  color: var(--text-light);\n  margin: 16px 0 8px 0;\n  padding-left: 4px;\n  font-weight: 500;\n}\n\n.category-set-group:first-child .category-set-heading {\n  margin-top: 0;\n}\n\n/* Category Grid */\n.category-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n}\n\n.category-card {\n  background: white;\n  border: 3px solid var(--cat-color);\n  border-radius: 16px;\n  padding: 20px 12px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n.category-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  background: var(--cat-color);\n}\n\n.category-card:hover .category-name {\n  color: white;\n}\n\n.category-icon {\n  font-size: 40px;\n  display: block;\n}\n\n.category-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text);\n  line-height: 1.2;\n}\n\n/* Learned category badge */\n.category-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: var(--success);\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n}\n\n/* Unlearned categories - grayed out */\n.category-card.unlearned {\n  border-color: #ddd;\n  opacity: 0.6;\n}\n\n.category-card.unlearned .category-icon {\n  filter: grayscale(70%);\n}\n\n.category-card.unlearned:hover {\n  opacity: 1;\n  border-color: var(--cat-color);\n  background: var(--cat-color);\n}\n\n.category-card.unlearned:hover .category-icon {\n  filter: none;\n}\n\n/* Selected Category Banner */\n.selected-category {\n  background: var(--cat-color);\n  border-radius: 16px;\n  padding: 16px 24px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  color: white;\n  box-shadow: var(--shadow);\n}\n\n.selected-icon {\n  font-size: 36px;\n}\n\n.selected-name {\n  font-size: 20px;\n  font-weight: 700;\n  flex: 1;\n}\n\n.change-category-btn {\n  background: rgba(255, 255, 255, 0.25);\n  border: none;\n  color: white;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.change-category-btn:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n/* Games Grid */\n.games-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n}\n\n.game-card {\n  background: white;\n  border-radius: 20px;\n  padding: 28px 20px;\n  text-align: center;\n  text-decoration: none;\n  color: var(--text);\n  box-shadow: var(--shadow);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.game-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);\n}\n\n.game-icon {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.game-card h3 {\n  font-size: 18px;\n  margin-bottom: 6px;\n}\n\n.game-card p {\n  font-size: 13px;\n  color: var(--text-light);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
